/**
 * IntegerIcon/index.js
 * desc: integer data-type icon
 * note: type icon via IconButton; defaults its tooltip + accessible name to the
 *       data-type title. Exported as both the default and a named (ref-able) component.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


export const IntegerIcon = ({ tooltip, ref, ...props }) => {
    return (
        <IconButton ref={ ref } baseClassName="integer icon" label={ tooltip || translate('icons.integer.tooltip.text') } tooltip={ tooltip } { ...props }>
            <svg viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m3.858 8 1.313-8h.781L4.64 8h-.782ZM.218 5.781.343 5h5.969l-.125.781H.217ZM1.046 8l1.312-8h.782L1.827 8h-.781Zm-.36-5 .126-.781H6.78L6.655 3H.687Z"/></svg>
        </IconButton>
    );
};


export default IntegerIcon;
